import {QtyType} from '@px/enum/order';
import {storageUtil} from '@px/helper/storage';

interface ContractSymbolStorage extends StorageObject {
  quantityEv: number;
  postOnly: boolean;
  reduceOnly: boolean;
  closeOnTrigger: boolean;
  slTrigger: string;
  timeInForce: string;
  triggerType: string;
  conditionalType: string;
  qtyType: string;
}

interface CommonContractSymbolStorage extends StorageObject {
  qtyType: QtyType;
}

const STORAGE_KEY_PREFIX = 'contract_symbol_cache_';
const STORAGE_BEFORE_V2 = 'common_contract_cache_before_v2';
const STORAGE_V2 = 'common_contract_cache_v2';

// 以双向持仓为分界线，委托单位统一
export const commonContractSymbolStorage = {
  _getStorageKey(contractType: TradeType): string {
    return contractType === 'Perpetual' ? STORAGE_BEFORE_V2 : STORAGE_V2;
  },
  readContractSymbolStorage(contractType: TradeType): CommonContractSymbolStorage {
    const storageKey = commonContractSymbolStorage._getStorageKey(contractType);
    return storageUtil.readStorageObject(storageKey, createInitCommonContractSymbolStorage(contractType));
  },
  updateContractSymbolStorage(contractType: TradeType, kv: Record<string, any>) {
    const storageKey = commonContractSymbolStorage._getStorageKey(contractType);
    storageUtil.writeStorageObject(storageKey, {...commonContractSymbolStorage.readContractSymbolStorage(contractType), ...kv});
  },
};

export const contractSymbolStorage = {
  readContractSymbolStorage(symbol: string): ContractSymbolStorage {
    const customStorage = storageUtil.readStorageObject(STORAGE_KEY_PREFIX + symbol, createInitContractSymbolStorage());
    return {...customStorage};
  },
  updateContractSymbolStorage(symbol: string, kv: Record<string, any>) {
    storageUtil.writeStorageObject(STORAGE_KEY_PREFIX + symbol, {...contractSymbolStorage.readContractSymbolStorage(symbol), ...kv});
  },
};

function createInitContractSymbolStorage(): ContractSymbolStorage {
  const baseStorage = {
    version: 1,
    quantityEv: 0,
    postOnly: false,
    reduceOnly: false,
    closeOnTrigger: false,
    slTrigger: 'ByLastPriceLimit',
    timeInForce: 'GoodTillCancel',
    triggerType: 'ByLastPrice',
    conditionalType: 'Limit',
    qtyType: QtyType.Base,
  };
  return {...baseStorage};
}

function createInitCommonContractSymbolStorage(contractType: TradeType): CommonContractSymbolStorage {
  return {
    version: 1,
    qtyType: contractType === 'PerpetualV2' ? QtyType.Coin : QtyType.Base,
  };
}
